import { useCurrentUserQuery, UserDetailsFragment } from "src/generated/graphql-types";

export function useCurrentUser(): UserDetailsFragment {
  const { data } = useCurrentUserQuery({
    fetchPolicy: "cache-first",
  });

  return data?.currentUser ?? ({} as UserDetailsFragment);
}
